module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "max-width": _vm.isMovil ? '100%' : '50%',
      "transition": "dialog-bottom-transition",
      "fullscreen": _vm.isMovil
    },
    model: {
      value: (_vm.isUploadAvatar),
      callback: function($$v) {
        _vm.isUploadAvatar = $$v
      },
      expression: "isUploadAvatar"
    }
  }, [_c('v-card', [(_vm.isUploadAvatar) ? _c('adjuntar-archivos', {
    ref: "archivos",
    attrs: {
      "multiple": false,
      "extensions": ['png', 'jpg', 'jpeg'],
      "accept": ['image/*'],
      "label": "Elegir como perfil",
      "is-set-profile": true
    },
    on: {
      "close": _vm.closeModalAdjuntar,
      "save": _vm.getImagenToProfile
    }
  }) : _vm._e()], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    },
    model: {
      value: (_vm.isActiveAccount),
      callback: function($$v) {
        _vm.isActiveAccount = $$v
      },
      expression: "isActiveAccount"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-25 py-2"
  }, [_vm._v("Activar cuenta")]), _c('v-card-text', [_c('span', [_vm._v("Verifica los datos y dale confirmar si realmente deseas aprobar la siguiente cuenta de Help Desk.")]), _c('strong', {
    staticClass: "ml-3 primary--text"
  }, [_vm._v(_vm._s(_vm.usuario.razonSocial))])]), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.closeModalIsActiveAccount()
      }
    }
  }, [_c('small', [_vm._v("Cancelar")])]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "loading": _vm.isLoadingActivating,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchActivateAccount()
      }
    }
  }, [_c('small', [_vm._v("Confirmar")])])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "500",
      "transition": "dialog-bottom-transition"
    },
    on: {
      "click:outside": function($event) {
        return _vm.closeModalSetPassword()
      }
    },
    model: {
      value: (_vm.isSetPassword),
      callback: function($$v) {
        _vm.isSetPassword = $$v
      },
      expression: "isSetPassword"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700 font-size-20 py-2"
  }, [_vm._v(_vm._s(!_vm.validar ? 'Ingresa la contraseña actual del usuario, para guardar los cambios realizados.' : 'Ingresa tu contraseña actual, para guardar los cambios realizados.'))]), _c('v-card-text', [_c('v-text-field', {
    ref: "currentPassword",
    staticClass: "pt-6",
    attrs: {
      "dense": "dense",
      "hide-details": "hide-details",
      "append-icon": !_vm.showPassword ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword ? 'text' : 'password',
      "label": "Contraseña actual"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword = !_vm.showPassword
      }
    },
    model: {
      value: (_vm.currentPassword),
      callback: function($$v) {
        _vm.currentPassword = $$v
      },
      expression: "currentPassword"
    }
  })], 1), _c('v-card-actions', [_c('v-spacer'), (!_vm.isMovil) ? _c('v-btn', {
    attrs: {
      "color": "ligth",
      "text": "",
      "small": "small"
    },
    on: {
      "click": function($event) {
        return _vm.closeModalSetPassword()
      }
    }
  }, [_vm._v("Cancelar")]) : _vm._e(), _c('v-btn', {
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCambios(true)
      }
    }
  }, [_vm._v("Confirmar")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "elevation-1 pa-3"
  }, [(!Object.keys(_vm.usuario).length) ? _c('v-skeleton-loader', {
    attrs: {
      "type": "list-item-avatar-two-line",
      "height": "100px"
    }
  }) : _c('v-list', {
    staticClass: "py-0",
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-item', [_c('div', {
    staticClass: "position-relative"
  }, [_c('v-avatar', {
    staticClass: "elevation-1",
    attrs: {
      "size": _vm.isMovil ? 50 : 70
    }
  }, [_c('avatar-perfil', {
    attrs: {
      "path": _vm.usuario.foto,
      "gradient": "gradient"
    }
  })], 1), (_vm.perfil === 'sistemas' || _vm.usuarioLogged === _vm.usuario.usuario) ? _c('v-btn', {
    staticClass: "position-absolute floatt",
    attrs: {
      "fab": "fab",
      "color": "primary white--text"
    },
    on: {
      "click": function($event) {
        return _vm.openModalAdjuntar()
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e()], 1), _c('v-list-item-content', {
    staticClass: "ml-3"
  }, [_c('v-list-item-title', {
    staticClass: "font-weight-700",
    class: _vm.isMovil ? 'font-size-17' : 'font-size-17',
    domProps: {
      "textContent": _vm._s(_vm.usuario.nombre)
    }
  }), _c('v-list-item-subtitle', {
    class: _vm.isMovil ? 'font-size-12' : 'font-size-12'
  }, [_c('span', [_vm._v(_vm._s(_vm.usuario.cargo))]), (_vm.perfil !== 'usuario-contrato' && _vm.perfil !== 'usuario-contrato') ? _c('span', [_vm._v("  (" + _vm._s(_vm.usuario.tipoArea) + "/" + _vm._s(_vm.usuario.zonaGarantia) + ")")]) : _vm._e()])], 1)], 1)], 1), _c('div', {
    staticClass: "mt-4"
  }, [(_vm.perfil === 'sistemas' || _vm.usuarioLogged === _vm.usuario.usuario) ? _c('v-tabs', {
    attrs: {
      "color": "primary"
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab', {
    key: "tab-datos"
  }, [_vm._v("Datos")]), _c('v-tab', {
    key: "tab-reset-password"
  }, [_vm._v("cambiar contraseña")])], 1) : _vm._e(), _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_c('v-tab-item', {
    key: "tab-datos"
  }, [_c('v-form', {
    staticClass: "pa-2",
    class: _vm.validar ? 'box-data-desktop-validar' : 'box-data-desktop'
  }, [(!_vm.isUsuarioEmpresa) ? _c('v-slide-group', {
    staticClass: "my-2",
    attrs: {
      "mandatory": "mandatory",
      "show-arrows": ""
    },
    model: {
      value: (_vm.usuario.entidad),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "entidad", $$v)
      },
      expression: "usuario.entidad"
    }
  }, _vm._l((_vm.tiposUsuario), function(n, index) {
    return _c('v-slide-item', {
      key: index,
      staticClass: "animated fadeInLeft faster",
      attrs: {
        "value": n.value
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(ref) {
          var active = ref.active;
          var toggle = ref.toggle;

          return [_c('v-card', {
            staticClass: "elevation-1 ma-1 d-flex ai-center jc-center text-center fd-column",
            attrs: {
              "color": active ? 'primary' : 'secondary primary--text',
              "height": "85",
              "dark": active,
              "disabled": _vm.isUsuarioEmpresa,
              "width": _vm.isMovil ? '100%' : '150px'
            },
            on: {
              "click": toggle
            }
          }, [_c('v-icon', {
            attrs: {
              "size": "30",
              "color": active ? 'white' : 'primary'
            }
          }, [_vm._v(_vm._s(n.icon))]), _c('span', {
            staticClass: "font-size-13 font-weight-700"
          }, [_vm._v(_vm._s(n.name))])], 1)]
        }
      }], null, true)
    })
  }), 1) : _vm._e(), _c('v-row', {
    staticClass: "pt-4 mt-8"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex relative w-full"
  }, [_c('v-text-field', {
    ref: "email",
    attrs: {
      "disabled": _vm.validar,
      "dense": "dense",
      "type": "email",
      "label": "Usuario (email)"
    },
    on: {
      "keyup": _vm.lowercase
    },
    model: {
      value: (_vm.usuario.usuario),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "usuario", $$v)
      },
      expression: "usuario.usuario"
    }
  }), _c('v-fade-transition', [_vm._v("(leave-absolute='')"), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-icon', _vm._g(_vm._b({
          attrs: {
            "center": "",
            "size": "20",
            "color": _vm.usuario.emailConfirmado ? 'success' : 'warning'
          }
        }, 'v-icon', attrs, false), on), [_vm._v(_vm._s(_vm.usuario.emailConfirmado ? 'check_circle' : 'do_not_disturb_on'))])]
      }
    }])
  }, [_c('small', [_vm._v(_vm._s(_vm.usuario.emailConfirmado ? 'Email verificado' : 'No verificado'))])])], 1)], 1)]), (_vm.usuario.entidad === 'persona natural') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "documento",
    attrs: {
      "dense": "dense",
      "type": "number",
      "label": "Nro. Documento (DNI) *"
    },
    model: {
      value: (_vm.usuario.documento),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "documento", $$v)
      },
      expression: "usuario.documento"
    }
  })], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    ref: "ruc",
    attrs: {
      "dense": "dense",
      "label": "Nro. RUC",
      "counter": "counter",
      "maxlength": "11",
      "type": "number"
    },
    model: {
      value: (_vm.usuario.ruc),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ruc", $$v)
      },
      expression: "usuario.ruc"
    }
  }), (_vm.perfil === 'sistemas') ? _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "small": "small"
          },
          on: {
            "click": function($event) {
              return _vm.fetchGetDatosSunat()
            }
          }
        }, 'v-btn', attrs, false), on), [_c('img', {
          attrs: {
            "src": require("../assets/sunat.svg"),
            "width": "25",
            "height": "25"
          }
        })])]
      }
    }], null, false, 3793452433)
  }, [_c('small', [_vm._v("Obtener datos de SUNAT")])]) : _vm._e()], 1)]) : _vm._e(), (_vm.usuario.entidad === 'persona natural') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "nombreCompleto",
    attrs: {
      "dense": "dense",
      "label": "Nombre completo *"
    },
    on: {
      "keyup": function (e) {
        _vm.usuario.nombre = e.target.value.toUpperCase()
      }
    },
    model: {
      value: (_vm.usuario.nombre),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "nombre", $$v)
      },
      expression: "usuario.nombre"
    }
  })], 1) : _vm._e(), (_vm.usuario.entidad === 'empresa') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "razonsocial",
    attrs: {
      "dense": "dense",
      "label": "'Razon Social *"
    },
    on: {
      "keyup": function (e) {
        _vm.usuario.razonSocial = e.target.value.toUpperCase()
      }
    },
    model: {
      value: (_vm.usuario.razonSocial),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "razonSocial", $$v)
      },
      expression: "usuario.razonSocial"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    ref: "telefono",
    attrs: {
      "type": "number",
      "counter": "counter",
      "maxlength": "10",
      "dense": "dense",
      "label": "Telefono / Celular *"
    },
    model: {
      value: (_vm.usuario.telefono),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "telefono", $$v)
      },
      expression: "usuario.telefono"
    }
  })], 1)], 1), (_vm.usuario.entidad === 'empresa') ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Nombre contacto *"
    },
    model: {
      value: (_vm.usuario.nombre),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "nombre", $$v)
      },
      expression: "usuario.nombre"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "type": "documento",
      "label": "Nro. Documento del contacto *"
    },
    model: {
      value: (_vm.usuario.documento),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "documento", $$v)
      },
      expression: "usuario.documento"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Cargo del contacto"
    },
    model: {
      value: (_vm.usuario.cargo),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "cargo", $$v)
      },
      expression: "usuario.cargo"
    }
  })], 1)], 1) : _vm._e(), _c('v-row', [(_vm.usuario.entidad !== 'empresa') ? _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "dense": "dense",
      "label": "Cargo"
    },
    model: {
      value: (_vm.usuario.cargo),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "cargo", $$v)
      },
      expression: "usuario.cargo"
    }
  })], 1) : _vm._e(), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": _vm.usuario.entidad === 'empresa' ? 12 : 9
    }
  }, [_c('v-text-field', {
    ref: "direccion",
    attrs: {
      "dense": "dense",
      "type": "text",
      "label": "Dirección fiscal *"
    },
    model: {
      value: (_vm.usuario.direccion),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "direccion", $$v)
      },
      expression: "usuario.direccion"
    }
  })], 1)], 1), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('v-text-field', {
    attrs: {
      "dense": "",
      "label": "Ubigeo",
      "type": "number",
      "loading": _vm.isLoadingUbigeos
    },
    model: {
      value: (_vm.usuario.ubigeo),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "ubigeo", $$v)
      },
      expression: "usuario.ubigeo"
    }
  }), _c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "ml-4",
          attrs: {
            "fab": "fab",
            "color": "primary",
            "small": "small",
            "disabled": _vm.isLoadingUbigeos
          },
          on: {
            "click": function($event) {
              return _vm.fetchUbigeos(true)
            }
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("sync")])], 1)]
      }
    }])
  }, [_c('small', [_vm._v("Obtener ubigeo")])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.departamentos,
      "dense": "",
      "label": "Departamento"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('departamento')
      }
    },
    model: {
      value: (_vm.usuario.departamento),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "departamento", $$v)
      },
      expression: "usuario.departamento"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.provincias,
      "dense": "",
      "label": "Provincia"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('provincia')
      }
    },
    model: {
      value: (_vm.usuario.provincia),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "provincia", $$v)
      },
      expression: "usuario.provincia"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.distritos,
      "dense": "",
      "label": "Distrito"
    },
    on: {
      "change": function($event) {
        return _vm.rellenarInformacion('distrito')
      }
    },
    model: {
      value: (_vm.usuario.distrito),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "distrito", $$v)
      },
      expression: "usuario.distrito"
    }
  })], 1)], 1), (_vm.perfil === 'sistemas') ? _c('div', {
    staticClass: "d-flex mt-6"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.perfiles,
      "disabled": _vm.validar,
      "hide-details": "hide-details",
      "label": "Perfil para el aplicativo",
      "dense": "",
      "item-value": "nombre",
      "item-text": "nombre"
    },
    model: {
      value: (_vm.usuario.perfil),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "perfil", $$v)
      },
      expression: "usuario.perfil"
    }
  }), _c('v-select', {
    staticClass: "mx-4",
    attrs: {
      "items": _vm.zonasGarantia,
      "disabled": _vm.validar,
      "hide-details": "hide-details",
      "label": "Zona de garantia",
      "dense": ""
    },
    model: {
      value: (_vm.usuario.zonaGarantia),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "zonaGarantia", $$v)
      },
      expression: "usuario.zonaGarantia"
    }
  }), _c('v-select', {
    attrs: {
      "items": _vm.tipoAreas,
      "disabled": _vm.validar,
      "hide-details": "hide-details",
      "label": "Tipo de area",
      "dense": ""
    },
    model: {
      value: (_vm.usuario.tipoArea),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "tipoArea", $$v)
      },
      expression: "usuario.tipoArea"
    }
  })], 1) : _vm._e(), (_vm.perfil === 'sistemas') ? _c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Puede cambiar ruc del cliente"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function() {
        return [_c('div', {
          on: {
            "click": function($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v("Puede cambiar ruc del cliente")])]
      },
      proxy: true
    }], null, false, 2522306904),
    model: {
      value: (_vm.usuario.puedeCambiarRucDeCliente),
      callback: function($$v) {
        _vm.$set(_vm.usuario, "puedeCambiarRucDeCliente", $$v)
      },
      expression: "usuario.puedeCambiarRucDeCliente"
    }
  }) : _vm._e()], 1)], 1), _c('v-tab-item', {
    key: "tab-reset-password"
  }, [_c('v-form', {
    staticClass: "pa-2",
    class: {
      'box-data-movil': _vm.isMovil, 'box-data-desktop': !_vm.validar, 'box-data-desktop-validar': _vm.validar
    }
  }, [_c('v-alert', {
    staticClass: "my-2",
    attrs: {
      "icon": "info",
      "outlined": "outlined",
      "text": "",
      "type": "info"
    }
  }, [_c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-weight-700 font-size-14"
  }, [_vm._v("Nota")]), _c('span', {
    staticClass: "font-size-11"
  }, [_vm._v(" Al realizar el cambio de tu contraeña, tendras que volver a iniciar sesión")])])]), _c('v-text-field', {
    ref: "password",
    staticClass: "pt-4",
    attrs: {
      "prepend-icon": "lock",
      "append-icon": !_vm.showPassword1 ? 'visibility' : 'visibility_off',
      "type": _vm.showPassword1 ? 'text' : 'password',
      "label": "Ingrese una contraseña",
      "loading": "loading",
      "hint": "La contraseña que ingreses sera encriptada para mayor privacidad y seguridad",
      "persistent-hint": "persistent-hint"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword1 = !_vm.showPassword1
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGuardarCambios()
      }
    },
    scopedSlots: _vm._u([{
      key: "progress",
      fn: function() {
        return [_c('v-progress-linear', {
          attrs: {
            "value": _vm.progress,
            "color": _vm.color,
            "absolute": "",
            "height": "2"
          }
        })]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.newPassword),
      callback: function($$v) {
        _vm.newPassword = $$v
      },
      expression: "newPassword"
    }
  }), _c('v-text-field', {
    staticClass: "pt-4",
    attrs: {
      "dense": "dense",
      "prepend-icon": "lock",
      "type": _vm.showPassword2 ? 'text' : 'password',
      "append-icon": !_vm.showPassword2 ? 'visibility' : 'visibility_off',
      "label": "Repita la contraseña nueva"
    },
    on: {
      "click:append": function($event) {
        _vm.showPassword2 = !_vm.showPassword2
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchGuardarCambios()
      }
    },
    model: {
      value: (_vm.newPasswordRepeat),
      callback: function($$v) {
        _vm.newPasswordRepeat = $$v
      },
      expression: "newPasswordRepeat"
    }
  })], 1)], 1)], 1), ((_vm.perfil === 'dispatcher' || _vm.perfil === 'supervisor' || _vm.perfil === 'sistemas') && _vm.usuario.perfil === 'usuario-contrato') ? _c('v-card', {
    staticClass: "mx-auto position-absolute position-active",
    attrs: {
      "elevation": "2",
      "absolute": "absolute",
      "min-height": "210px",
      "max-height": "300px",
      "min-width": "300px",
      "max-width": "300px"
    }
  }, [_c('v-card-item', [_c('v-card-title', {
    staticClass: "py-2"
  }, [_c('strong', {
    staticClass: "font-size-17"
  }, [_vm._v("Historial de inicio")])])], 1), _c('v-divider'), _c('v-card-text', [_c('div', {
    staticClass: "d-flex fd-column mb-2"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Estado de email")]), (_vm.usuario.emailConfirmado) ? _c('strong', {
    staticClass: "success--text"
  }, [_vm._v("Verificado")]) : _c('strong', {
    staticClass: "warning--text"
  }, [_vm._v("No verificado")])]), _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('span', {
    staticClass: "font-size-12"
  }, [_vm._v("Activación de cuenta")]), (_vm.usuario.emailConfirmado && _vm.usuario.fechaCuentaActivada) ? _c('div', {
    staticClass: "d-flex fd-column"
  }, [_c('strong', {
    staticClass: "success--text mb-1"
  }, [_vm._v("Activado")]), _c('div', {
    staticClass: "d-flex font-size-12 gray--text"
  }, [_c('span', [_vm._v("El")]), _c('strong', {
    staticClass: "mx-1"
  }, [_vm._v(_vm._s(_vm._f("fecha")(_vm.usuario.fechaCuentaActivada)))]), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v("por")]), _c('strong', [_vm._v(" " + _vm._s(_vm.usuario.nombreUsuarioCuentaActivada))])])]) : _c('strong', {
    staticClass: "warning--text"
  }, [_vm._v("No activado")]), ((_vm.perfil === 'dispatcher' || _vm.perfil === 'supervisor' || _vm.perfil === 'sistemas') && _vm.usuario.emailConfirmado && !_vm.usuario.fechaCuentaActivada) ? _c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "info",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.openModalIsActiveAccount()
      }
    }
  }, [_c('small', [_vm._v("Activar cuenta")])]) : _vm._e()], 1)])], 1) : _vm._e(), (_vm.perfil === 'sistemas' || _vm.usuarioLogged === _vm.usuario.usuario) ? _c('div', {
    staticClass: "d-flex align-end -end jc-end"
  }, [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "color": "success",
      "block": _vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.fetchGuardarCambios()
      }
    }
  }, [_c('small', [_vm._v("Guardar cambios")])])], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-723f9e35","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_usuario_form_editar_datos.vue
// module id = 506
// module chunks = 1